import { render, staticRenderFns } from "./DiscreteEnviroData.vue?vue&type=template&id=be7a2652"
import script from "./DiscreteEnviroData.vue?vue&type=script&lang=js"
export * from "./DiscreteEnviroData.vue?vue&type=script&lang=js"
import style0 from "./DiscreteEnviroData.vue?vue&type=style&index=0&id=be7a2652&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports